import { API } from './api';

const authServices = {
  async login(data) {
    try {
      // api.ts의 PUBLIC_ENDPOINTS에 '/auth/login'이 포함되어 있어 토큰이 자동으로 제외됨
      const res = await API.post('/auth/login', data);
      return { data: res?.data, error: null };
    } catch (err) {
      return { error: err?.response?.data || err, data: null };
    }
  },
};

export default authServices;
